export interface Permission {
  actions: string[];
  resource: string;
  resourceType: string;
}
